import {
  defaultApplicationText,
  qldApplicationText,
} from 'app/constants/application-settings.constants'
import { stateConverter } from 'app/sm/helpers'
import { QLD } from 'app/utils/address/helpers'
import { isQLDForm22Disabled } from 'config/features'

interface IncomeTableData {
  type: string
  income: number
}

export const incomeLimitFromGroup = (
  group: string,
  incomeTableData: IncomeTableData[] = [],
): number => {
  if (group && incomeTableData.length > 0) {
    const incomeLimitData = incomeTableData.find(({ type }) => {
      if (group === 'Group') {
        return type === 'Family'
      }
      return type === group
    })
    const { income = 0 } = incomeLimitData || {}
    return income
  } else {
    return 0
  }
}

export const applicationText = (
  isQLDForm: boolean,
  textKey: keyof typeof defaultApplicationText,
): string | undefined => {
  if (isQLDForm) {
    return qldApplicationText[textKey]
  } else {
    return defaultApplicationText[textKey]
  }
}

export const isQLDForm22 = (state: string, teamSlug: string): boolean => {
  if (isQLDForm22Disabled(teamSlug)) return false

  return isQLDApplication(state)
}

export const isQLDApplication = (state: string): boolean => {
  return stateConverter(state) === QLD
}
